import { Charts } from './Charts';
import HouseHoldVisitChartsDataProvider from './contexts/HouseHoldVisitChartsDataContext';

const HouseHoldVisitWrapper = () => {
    return (
        <HouseHoldVisitChartsDataProvider>
            <Charts />
        </HouseHoldVisitChartsDataProvider>
    );
};

export default HouseHoldVisitWrapper;
